import React, { useCallback, useMemo, useRef } from 'react';
import { Select } from '@osui/ui';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

function ProSelect({
  withSelectAll,
  ...props
}) {
  const oldValue = useRef([]);
  const isUseSelectAll = useMemo(() => {
    return props.mode === 'multiple' && withSelectAll;
  }, [props, withSelectAll]);
  const options = useMemo(() => {
    return isUseSelectAll && props.options && props.options.length > 0 ? [{
      value: 'ALL',
      label: '全选'
    }, ...props.options] : props.options || [];
  }, [isUseSelectAll, props.options]);
  const onChange = useCallback(value => {
    let newValue = value;

    if (isUseSelectAll && props.options) {
      if (value[value.length - 1] === 'ALL') {
        // 当value的最后一个值是ALL的时候 说明勾上全选。
        newValue = props.options.map(i => i.value);
      } else if (value.includes('ALL') && value.length < props.options.length + 1) {
        // 当value里面有all 但是value的数量小于options的数量 说明是选中了其他此时取消按钮显示关闭
        newValue = value.filter(n => n !== 'ALL');
      } else if (value.length === props.options.length && value.length === oldValue.current.length) {
        // 当新值长度和全部相等，且旧值长度也和全部相等 此时是全选后点击全选取消全选
        newValue = [];
      }

      oldValue.current = newValue;
    }

    props.onChange && props.options && props.onChange(newValue, props.options);
  }, [isUseSelectAll, props]);
  const value = useMemo(() => {
    if (isUseSelectAll && Array.isArray(props.value)) {
      var _props$options;

      return props.value.length === ((_props$options = props.options) === null || _props$options === void 0 ? void 0 : _props$options.length) ? ['ALL', ...props.value] : props.value;
    } else {
      return props.value;
    }
  }, [props, isUseSelectAll]);
  const tagRender = useMemo(() => {
    const isStringArray = v => Array.isArray(v) && typeof v[0] === 'string';

    return isUseSelectAll && isStringArray(value) && value.includes('ALL') ? props => {
      return props.value === 'ALL' ? /*#__PURE__*/_jsx("span", {
        children: "\u5DF2\u5168\u9009"
      }) : /*#__PURE__*/_jsx(_Fragment, {});
    } : props.tagRender;
  }, [isUseSelectAll, props.tagRender, value]);
  return /*#__PURE__*/_jsx(Select, { ...props,
    options: options,
    onChange: onChange,
    value: value,
    tagRender: tagRender
  });
}

ProSelect.displayName = "ProSelect";
export default ProSelect;
//# sourceMappingURL=es/Select.js.map